import { IconMail, IconSettings, IconLockCog } from '@tabler/icons-react';

const settings = {
    id: 'settings',
    title: 'SETTINGS',
    icon: IconSettings,
    type: 'group',
    children: [
        {
            id: 'settings-email-template',
            title: 'EMAIL TEMPLATES',
            type: 'item',
            url: '/email-templates',
            icon: IconMail,
            breadcrumbs: false,
            tags: ['setting', 'settings', 'email', 'template', 'template']
        },
        {
            id: 'settings-access-management',
            title: 'ACCESS MANAGEMENT',
            icon: IconLockCog,
            type: 'item',
            url: '/access-management',
            breadcrumbs: false,
            tags: [
                'access',
                'access management',
                'access control',
                'support',
                'help',
                'support ticket',
                'ticket',
                'tickets',
                'issue',
                'issues',
                'problem',
                'bug',
                'report issue',
                'help request',
                'support request',
                'customer support',
                'client support'
            ],
            // this will hold all the pages or pages card that will show in the page
            dynamicPages: [
                {
                    title: 'Dash Users',
                    tags: [
                        'dash users',
                        'dashboard users',
                        'users',
                        'user accounts',
                        'account users',
                        'system users',
                        'platform users',
                        'admin users',
                        'admin accounts'
                    ],
                    urlParams: 'dash-users'
                },
                {
                    title: 'Deployment Groups',
                    tags: [
                        'deployment group',
                        'deployment groups',
                        'groups',
                        'client groups',
                        'organisation groups',
                        'organization groups',
                        'deployment categories',
                        'deployment collections'
                    ],
                    urlParams: 'deployment-groups'
                }
            ]
        }
    ]
};

export default settings;
